<template>
  <div>
    <van-divider />
    <div v-show="List != null" v-cloak>
      <div v-if="List && List.length > 0" style="padding:  15px  20px 60px">

        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div v-for="(item, index) in List" :key="index" class="css-display">
            <div style="text-align: center;font-size: 20px;font-weight: 700;padding: 0 10px;background-color:#ffffff;">
              {{ item.addr }}
            </div>

            <div class="p10-size14">
              <div class="title-s">创建人</div>
              <div class="value-s">{{ item.creator_username }}</div>
            </div>
            <div class="p10-size14">
              <div class="title-s">创建时间</div>
              <div class="value-s">{{ item.created_at }}</div>
            </div>

            <div class="filds">
              <div class="paddingXm">
                <van-uploader :max-count="5" v-model="item.images" :disabled="true" :deletable="false" multiple
                  :show-upload="false" />
              </div>
            </div>
            <div class="p10-size14">
              <div class="title-s">备注</div>
              <div class="value-s">{{ item.remark }}</div>
            </div>


            <div style="padding:10px 10px 0;">
              <button @click="skipDetail(item)" class="buto">查看</button>
              <button @click="delet(item)" class="buto" style="margin-left: 20px;background-color: crimson;">删除</button>

            </div>

          </div>

        </van-list>

      </div>
      <div v-show="List.length == 0">
        <van-empty description="暂无信息" />
      </div>
    </div>

    <div class="footers">
      <div class="buttons" @click="add()"> 新建位置</div>
    </div>

  </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
export default {
  data () {
    return {
      caidian_id: '',
      List: [],
      total: 0,
      loading: false,
      finished: false,
      page: 0
    };
  },
  created () {
    this.caidian_id = this.$route.query.id
    this.reload()

  },
  beforeRouteEnter (to, from, next) {
    document.title = to.query.title
    next()
  },
  methods: {
    reload () {
      this.page = 0
      this.List = []
      this.loading = false
      this.finished = false
      this.getListInfo()
    },
    onLoad () {
      let that = this

      if (this.List.length == this.total) {
        that.loading = false
        that.finished = true
        return
      }
      setTimeout(() => {
        this.getListInfo(that.tabsName)
      }, 500)
    },
    getListInfo () {
      let that = this
      this.$axios.get('caidian/items', {
        params: {
          page: this.page,
          caidian_id: this.caidian_id
        }
      }).then(res => {
        let data = res.data.data
        console.log(data);
        for (let i = 0; i < data.length; i++) {
          data[i].title = data[i].addr
          data[i].images = []
          let datapics = data[i].pics

          if (datapics) {

            let pics = datapics.split(',')
            for (let j = 0; j < pics.length; j++) {
              console.log(data[i], '111');
              data[i].images.push({ url: pics[j] })


            }
            console.log(data[i], '11');
          }
          this.List.push(data[i])
        }
        this.total = res.data.total
        // this.List = this.List.contat(data)
        that.loading = false
        if (res.data.data.length == 0) {
          this.listShow = true
          that.finished = true
        }
      })
    },
    skipDetail (item) {

      // let query = {
      //   id: item.id,
      //   type: 'readonly'
      // }
      // console.log(query);

      this.$router.push({
        path: '/maploading',
        query: {
          id: item.id,
          type: 'readonly'
        }
      })
    },
    add () {
      this.$router.push({
        path: '/maploading',
        query: {
          artical_id: this.caidian_id,
          type: 'add'
        }
      })
    },
    delet (item) {
      let that = this
      Dialog.alert({
        title: '是否删除',
        showCancelButton: true
      }).then(res => {

        this.$axios.post('caidian/item-delete', {
          id: item.id
        }).then(res => {
          that.reload()

        })
      }).catch(err => {
        console.log(err);
      })

    }
  },
}
</script>
<style lang="scss" scoped>
.css-display {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #f1f1f1;
  padding: 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 4px rgba($color: #4c4d47, $alpha: 0.5);
  margin-bottom: 10px;
}

.buto {
  background-color: royalblue;
  padding: 5px 20px;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
}

.p10-size14 {
  padding: 12px 15px;
  font-size: 14px;

  .title-s {
    display: inline-block;
    width: 35%;
    font-weight: 500;
    // color: brown;
    // text-align: center;
  }

  .value-s {
    display: inline-block;
    color: #999;
    width: 65%;
    text-align: right;
  }
}

.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  // justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
  z-index: 1000;

  .buttons {
    background-color: darkseagreen;
    width: 100%;
    padding: 10px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .buttons:active {
    background-color: burlywood;
  }
}
</style>